import { useAction } from "../state/action";

export default function usePrerolling() {
	const action = useAction();

	return action && action.type === "start" && action.position && action.recordPosition;
}
